"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreThemes = require("@vfuk/core-themes");
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreCheckboxList = _interopRequireDefault(require("@vfuk/core-checkbox-list"));
var _reactI18next = require("react-i18next");
var Styled = _interopRequireWildcard(require("./styles/CompareCheckbox.style"));
var _CompareCheckbox2 = _interopRequireDefault(require("./themes/CompareCheckbox.theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CompareCheckbox = function CompareCheckbox(_ref) {
  var _compareOptions$label, _compareOptions$label2;
  var id = _ref.id,
    compareOptions = _ref.compareOptions,
    containerRef = _ref.containerRef,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    localTheme = _ref.localTheme,
    dataAttributes = _ref.dataAttributes,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  // localization
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  // Constants
  var defaultLabel = t('Compare');
  var componentName = 'CompareCheckbox';
  // hooks
  var compareCheckboxLocalTheme = (0, _coreThemes.useLocalTheme)(componentName, _CompareCheckbox2["default"], localTheme);
  var _useState = (0, _react.useState)(function () {
      var _compareOptions$initi;
      return (_compareOptions$initi = compareOptions === null || compareOptions === void 0 ? void 0 : compareOptions.initialValue) !== null && _compareOptions$initi !== void 0 ? _compareOptions$initi : false;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    checkedState = _useState2[0],
    setCheckedState = _useState2[1];
  // Semantic Radio Items
  var SemanticItemLabel = (_compareOptions$label = compareOptions === null || compareOptions === void 0 ? void 0 : compareOptions.label) !== null && _compareOptions$label !== void 0 ? _compareOptions$label : defaultLabel;
  var SemanticItemValue = ((_compareOptions$label2 = compareOptions === null || compareOptions === void 0 ? void 0 : compareOptions.label) !== null && _compareOptions$label2 !== void 0 ? _compareOptions$label2 : defaultLabel).toLowerCase();
  var radioItems = [{
    label: SemanticItemLabel,
    value: SemanticItemValue,
    checked: checkedState
  }];
  // can use useRef to get better perfomance?
  var updateCheckboxStates = (0, _react.useCallback)(function () {
    var _containerRef$current;
    setCheckedState(function (prev) {
      return !prev;
    });
    compareOptions === null || compareOptions === void 0 ? void 0 : compareOptions.onHandleCheckEvent({
      checked: !checkedState,
      id: (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.id
    }, containerRef);
  }, [compareOptions]);
  return /*#__PURE__*/_react["default"].createElement(Styled.CompareContainer, _extends({}, dataAttributes, {
    id: id,
    appearance: appearance,
    localTheme: compareCheckboxLocalTheme,
    "data-component-name": componentName,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }), /*#__PURE__*/_react["default"].createElement(_coreCheckboxList["default"], {
    orientation: "horizontal",
    fieldWrapper: {
      label: SemanticItemLabel,
      showLabel: false,
      width: 'full'
    },
    checkboxes: {
      groupName: 'Horizontal',
      id: "".concat(id, "-checkboxes"),
      onChange: updateCheckboxStates,
      items: radioItems
    },
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'checkbox-list')
  }));
};
CompareCheckbox.displayName = "CompareCheckbox";
CompareCheckbox.displayName = 'CompareCheckbox';
var _default = CompareCheckbox;
exports["default"] = _default;
//# sourceMappingURL=CompareCheckbox.js.map